import {FundsInformationComponent} from './funds.information.component';

export * from './funds.information.component'

export const FUNDS_INFORMATION_COMPONENTS = [
    FundsInformationComponent
];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/funds.information/index.ts